export { default as Img200 } from './processed/200/shoals.jpg';
export { default as Img400 } from './processed/400/shoals.jpg';
export { default as Imgthumb } from './processed/thumb/shoals.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/shoals.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/shoals.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      32,
      82,
      202
    ],
    "_population": 40,
    "_hsl": [
      0.6176470588235294,
      0.7264957264957265,
      0.4588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      166,
      180,
      232
    ],
    "_population": 480,
    "_hsl": [
      0.6313131313131313,
      0.5892857142857141,
      0.7803921568627451
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      34,
      40,
      75
    ],
    "_population": 352,
    "_hsl": [
      0.6422764227642276,
      0.3761467889908257,
      0.21372549019607845
    ]
  },
  "Muted": {
    "_rgb": [
      146,
      89,
      117
    ],
    "_population": 386,
    "_hsl": [
      0.9181286549707602,
      0.2425531914893617,
      0.46078431372549017
    ]
  },
  "LightMuted": {
    "_rgb": [
      157,
      143,
      200
    ],
    "_population": 117,
    "_hsl": [
      0.7076023391812866,
      0.341317365269461,
      0.6725490196078432
    ]
  },
  "DarkMuted": {
    "_rgb": [
      50,
      56,
      102
    ],
    "_population": 471,
    "_hsl": [
      0.6474358974358975,
      0.3421052631578948,
      0.2980392156862745
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/shoals.js